import { z } from "zod";
export const zClientCommonSchema = z.object({
    id: z.string(),
    email: z.string().nullish(),
    phone: z.string(),
    firstName: z.string(),
    lastName: z.string().nullish(),
    middleName: z.string().nullish(),
    dateOfBirth: z.string().nullish(),
    registrationDate: z.string().nullish(),
    isActive: z.boolean().nullish(),
    createdAt: z.string().nullish(),
    updatedAt: z.string().nullish(),
    isDeleted: z.boolean().nullish(),
    idCreatedBy: z.string().nullish(),
    idUpdatedBy: z.string().nullish(),
});
export const zClientFiltersSchema = z.object({
    search: z.string().optional(),
});
